export const ACCOUNT_ACCESS_TAGS = {
  CHECKOUT_API: (accountAccessId: string) => [
    'checkout-api-account-access',
    accountAccessId,
  ],
  CHECKOUT_API_FREEZE: (accountAccessId: string) => [
    'checkout-api-account-access',
    'freeze',
    accountAccessId,
  ],
  CHECKOUT_API_PROCESS: (searchParams: URLSearchParams | null) => [
    'checkout-api-account-access',
    'process',
    searchParams?.toString() ?? 'N/A',
  ],
  GLOBAL_API: (accountAccessId: string) => [
    'global-api-account-access',
    accountAccessId,
  ],
};
